export default __webpack_public_path__ + "static/media/sass.672732e2.png";